import { getRequestId } from '@qxwz/http-client';

export const AppName = 'merak-mall-web';

export const sessionRequestId = getRequestId();
